import { useMemo } from 'react'

import { useSelector } from 'react-redux'

import type { Group } from 'reducers/menu-groups/menuGroups'
import { getGroups } from 'selectors/menu-groups/getGroups'

export const useGroups = (): Group[] => {
  const groupsMap = useSelector(getGroups)

  // useMemo prevents components from infinite renders, Object.values always returns new array
  return useMemo(() => Object.values(groupsMap), [groupsMap])
}
